var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('page-flip')) : typeof define === 'function' && define.amd ? define(['react', 'page-flip'], factory) : (global = global || self, global.HTMLFlipBook = factory(global.React, global.pageFlip));
})(this, function (React, pageFlip) {
  'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  var HTMLFlipBook = /*#__PURE__*/function (_React$Component) {
    _inherits(HTMLFlipBook, _React$Component);

    var _super = _createSuper(HTMLFlipBook);

    function HTMLFlipBook() {
      _classCallCheck(this, HTMLFlipBook);

      return _super.apply(this, arguments);
    }

    _createClass(HTMLFlipBook, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.pageFlip = new pageFlip.PageFlip(this.el, this.props);
        this.pageFlip.loadFromHTML(this.childRef);
        this.setHandlers();
      }
    }, {
      key: "setHandlers",
      value: function setHandlers() {
        var _this = this;

        if (this.props.onFlip) this.pageFlip.on("flip", function (e) {
          return _this.props.onFlip(e);
        });
        if (this.props.onChangeOrientation) this.pageFlip.on("changeOrientation", function (e) {
          return _this.props.onChangeOrientation(e);
        });
        if (this.props.onChangeState) this.pageFlip.on("changeState", function (e) {
          return _this.props.onChangeState(e);
        });
        if (this.props.onInit) this.pageFlip.on("init", function (e) {
          return _this.props.onInit(e);
        });
        if (this.props.onUpdate) this.pageFlip.on("update", function (e) {
          return _this.props.onUpdate(e);
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.pageFlip.destroy();
        this.pageFlip = null;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) {
          this.pageFlip.off("flip");
          this.pageFlip.off("changeOrientation");
          this.pageFlip.off("changeState");
          this.pageFlip.off("init");
          this.pageFlip.off("update");
          this.pageFlip.updateFromHtml(this.childRef);
          this.setHandlers();
        }
      }
    }, {
      key: "getPageFlip",
      value: function getPageFlip() {
        return this.pageFlip;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        this.childRef = [];
        var childWithRef = React.Children.map(this.props.children, function (child) {
          return React.cloneElement(child, {
            ref: function ref(dom) {
              if (dom) _this2.childRef.push(dom);
            }
          });
        });
        return React.createElement("div", {
          ref: function ref(el) {
            return _this2.el = el;
          },
          className: this.props.className,
          style: this.props.style
        }, childWithRef);
      }
    }]);

    return HTMLFlipBook;
  }(React.Component);

  return HTMLFlipBook;
});